import { defineStore, storeToRefs } from 'pinia'
import { computed, ref, type Ref } from 'vue'
import { PluginKey, UserRightsEnum } from '@/generated'
import { useUserStore } from './user'

export const usePluginsStore = defineStore('plugins', () => {
  const { user } = storeToRefs(useUserStore())
  const enabledPlugins: Ref<PluginKey[]> = ref([])

  function setEnabledPlugins(plugins: PluginKey[]) {
    enabledPlugins.value = plugins
  }

  const isEdsEnabled = computed(() => enabledPlugins.value.includes(PluginKey.EDS))
  const isAkiEnabled = computed(() => enabledPlugins.value.includes(PluginKey.AKI))

  const isConnectEnabled = computed(
    () =>
      enabledPlugins.value.includes(PluginKey.CONNECT) ||
      user.value?.currentRole === UserRightsEnum.TCC_IT
  )

  return {
    enabledPlugins,
    setEnabledPlugins,
    isEdsEnabled,
    isConnectEnabled,
    isAkiEnabled
  }
})
